// src/i18n/fr.ts
import type { Translations } from "./index";

export const fr: Translations = {
  nav: {
    services: "Services",
    reviews: "Avis",
    contact: "Contact",
  },
  hero: {
    title: "Déménagements rapides et sûrs à Barcelone",
    subtitle:
      "Service de déménagement 24h à Barcelone et dans toute la Catalogne, assuré par une équipe professionnelle, un emballage sécurisé et un soin particulier pour chacun de vos biens. Obtenez votre devis immédiat sur WhatsApp, sans complications.",
    callNow: "Appeler maintenant",
    whatsapp: "WhatsApp",
  },
  quickQuote: {
    title: "Devis rapide",
    name: "Votre nom",
    from: "Adresse de départ",
    to: "Adresse d’arrivée",
    date: "Date",
    sendWhatsApp: "Envoyer par WhatsApp",
    helper:
      "Remplissez les champs et nous ouvrons WhatsApp avec le message prérempli.",
  },
  services: {
    title: "Services",
  },
  reviews: {
    title: "Avis clients",
    subtitle: "Note moyenne 4.9 ★ sur Google",
  },
  pricing: {
    title: "Tarifs indicatifs",
    note: "*Prix hors TVA. Parking et péages non inclus.",
  },
  contact: {
    title: "Contact",
    subtitle:
      "Demandez un devis par téléphone, WhatsApp ou email. Réponse en quelques minutes.",
    phone: "Tél. :",
    whatsapp: "WhatsApp :",
    email: "Email :",
    sendMediaTitle: "Envoyez-nous des photos ou une vidéo",
    sendMediaText:
      "Plus nous avons d’informations, meilleur sera le devis. Visite possible en appel vidéo.",
    openWhatsApp: "Ouvrir WhatsApp",
  },
};